const operateMixins = {
    data() {
      return {
        source: "",       //页面来源
        returnPath: "",    //返回页面
      }
    },
    methods: {
      //返回
      goBack(){
        this.$router.push({ path: this.returnPath});
      },
    },
    computed: {
      isLook(){
        return this.source=="detail";
      },
      isEdit(){
        return this.source=="edit";
      },
      isAdd(){
        return this.source=="add";
      },
      getTitle(){
        let title="";
        if(this.source=="add"){
          title="新增";
        }else if(this.source=="edit"){
          title="修改";
        }else if(this.source=="detail"){
          title="查看";
        }
        return title;
      }
    },
  };
  export default operateMixins;


// WEBPACK FOOTER //
// ./src/mixins/operate.js